import React, { memo } from "react"
import { Box } from "@chakra-ui/react"

type Props = {
  care: string
}

export const ProductContentCare: React.FC<Props> = memo(({ care }) => (
  <Box letterSpacing="generous" fontSize="sm" sx={{ ul: { pl: 3 } }} dangerouslySetInnerHTML={{ __html: care }} color="grey.text" />
))
